import { alpha, createTheme, darken } from '@mui/material'

// Color setup
const mainColor = '#D537A8'

const darkBackground = '#363D40'
const darkPrimaryMain = '#ec7a77'
const darkPrimaryLight = '#fbcf33'
const darkSecondary = '#f90283'
const darkError = '#DB488B'
const darkWarning = '#8C701B'
const darkInfo = '#3ED0EB'
const darkSuccess = '#0FBF9F'

const lightBackground = '#f7f8f9'
const lightPrimaryMain = '#344767'
const lightPrimaryLight = '#7928ca'
const lightSecondary = '#f90283'
const lightError = '#DB488B'
const lightWarning = '#8C701B'
const lightInfo = '#3ED0EB'
const lightSuccess = '#0FBF9F'
//

export const logInBackgroundImage = `radial-gradient(circle at 50% 14em, ${mainColor} 0%, #00023b 70%, #00023b 100%)`

const darkPalette = {
  background: { default: darkBackground },
  primary: { main: darkPrimaryMain, light: darkPrimaryLight },
  secondary: { main: darkSecondary },
  error: { main: darkError },
  warning: { main: darkWarning },
  info: { main: darkInfo },
  success: { main: darkSuccess },
  mode: 'dark',
}

const lightPalette = {
  background: { default: lightBackground },
  primary: { main: lightPrimaryMain, light: lightPrimaryLight },
  secondary: { main: lightSecondary },
  error: { main: lightError },
  warning: { main: lightWarning },
  info: { main: lightInfo },
  success: { main: lightSuccess },
  text: {
    // primary: "#544f5a",
    // secondary: "#89868D",
  },
  mode: 'light',
}

const componentsOverrides = (theme) => ({
  MuiBackdrop: {
    // styleOverrides: {
    //   root: {
    //     backgroundColor: alpha(darken("#000C57", 0.4), 0.2),
    //     backdropFilter: "blur(2px)",
    //     "&.MuiBackdrop-invisible": {
    //       backgroundColor: "transparent",
    //       backdropFilter: "blur(2px)",
    //     },
    //   },
    // },
  },
  MuiFormControl: {
    // defaultProps: {
    //   margin: "dense",
    // },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      input: {
        padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
      },
    },
  },
  MuiTab: {
    // styleOverrides: {
    //   root: {
    //     padding: 0,
    //     height: 38,
    //     minHeight: 38,
    //     borderRadius: 6,
    //     transition: "color .2s",
    //     "&.MuiButtonBase-root": {
    //       minWidth: "auto",
    //       paddingLeft: 20,
    //       paddingRight: 20,
    //       marginRight: 4,
    //     },
    //     "&.Mui-selected, &.Mui-selected:hover": {
    //       color: theme.palette.primary.contrastText,
    //       zIndex: 5,
    //     },
    //     "&:hover": {
    //       color: theme.palette.primary.main,
    //     },
    //   },
    // },
  },
  MuiTableRow: {
    // styleOverrides: {
    //   root: {
    //     "&:last-child td": { border: 0 },
    //   },
    // },
  },
  MuiTableCell: {
    // styleOverrides: {
    //   root: {
    //     padding: theme.spacing(2),
    //     "&.MuiTableCell-sizeSmall": {
    //       padding: theme.spacing(1.5),
    //     },
    //     "&.MuiTableCell-paddingNone": {
    //       padding: theme.spacing(0.5),
    //     },
    //   },
    // },
  },
  MuiTabs: {
    // styleOverrides: {
    //   root: {
    //     height: 38,
    //     minHeight: 38,
    //     overflow: "visible",
    //   },
    //   indicator: {
    //     height: 38,
    //     minHeight: 38,
    //     borderRadius: 6,
    //     border: `1px solid ${theme.palette.primary.light}`,
    //     boxShadow: theme.shadows[1],
    //   },
    //   scrollableX: {
    //     overflow: "visible !important",
    //   },
    // },
  },
  MuiTextField: {
    defaultProps: {
      variant: 'outlined',
    },
  },
  RaAppBar: {
    styleOverrides: {
      root: {
        color: theme.palette.text.primary,
        '& .RaAppBar-toolbar': {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.background.default,
          backgroundImage: `linear-gradient(310deg, ${theme.palette.primary.light}, ${theme.palette.secondary.main})`,
        },
      },
    },
  },
  RaMenuItemLink: {
    // styleOverrides: {
    //   root: {
    //     padding: 10,
    //     marginRight: 10,
    //     marginLeft: 10,
    //     "&:hover": {
    //       borderRadius: 5,
    //     },
    //     "&.RaMenuItemLink-active": {
    //       borderRadius: 10,
    //       backgroundColor: theme.palette.common.white,
    //       color: theme.palette.primary.main,
    //       "&:before": {
    //         content: '""',
    //         position: "absolute",
    //         top: "0; right: 0; bottom: 0; left: 0",
    //         zIndex: "-1",
    //         margin: "-2px",
    //         borderRadius: "12px",
    //         background: `linear-gradient(310deg, ${theme.palette.primary.light}, ${theme.palette.secondary.main})`,
    //       },
    //       "& .MuiSvgIcon-root": {
    //         fill: theme.palette.primary.main,
    //       },
    //     },
    //   },
    // },
  },
})

const createCustomTheme = (palette) => {
  const themeOptions = {
    palette,
    shape: { borderRadius: 10 },
    sidebar: { width: 250, closedWidth: 65 },
    spacing: 9,
    typography: {
      fontFamily: 'Gabarito, tahoma, sans-serif',
      h1: {
        fontWeight: 500,
        fontSize: '6rem',
      },
      h2: { fontWeight: 600 },
      h3: { fontWeight: 700 },
      h4: { fontWeight: 800 },
      h5: { fontWeight: 900 },
      button: { textTransform: undefined, fontWeight: 700 },
    },
  }
  const theme = createTheme(themeOptions)
  theme.components = componentsOverrides(theme)
  return theme
}

export const customLightTheme = createCustomTheme(lightPalette)
export const customDarkTheme = createCustomTheme(darkPalette)
